import { useMutation } from "@tanstack/react-query";
import {
	CreateLibraryDto,
	GetLibraryAndResourceDto,
	restRepository,
	UpdateLibraryDto,
} from "@onair/repositories";

export const useCreateLibraryMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: async (data: { id: string } & CreateLibraryDto) => {
			const { id, ...restData } = data;
			const response = await restRepository.api.libraryCreateSub(id, restData);
			return response.data;
		},
	});
};

export const useUpdateLibraryMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: async (data: { id: string } & UpdateLibraryDto) => {
			const { id, ...restData } = data;
			const response = await restRepository.api.libraryUpdateById(id, restData);
			return response.data;
		},
	});
};

export const useDeleteLibraryMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: async (id: string) => {
			const response = await restRepository.api.libraryDeleteById(id);
			return response.data;
		},
	});
};

export const useResourceSearchLibraryAndResourceByKeywordMutation = (
	options = {},
) => {
	return useMutation({
		...options,
		mutationFn: async (keyword: string) => {
			if (keyword) {
				const response =
					await restRepository.api.resourceSearchLibraryAndResourceByKeyword({
						keyword,
					});
				return response.data as GetLibraryAndResourceDto;
			}
		},
	});
};
